import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './css/index.css'
import "lib-flexible";
import './assets/iconfont/iconfont.css'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/vant-ui'

Vue.config.productionTip = false
Vue.use(Element)
router.beforeEach((to,from,next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
  	
  	//接下来写正常的路由守卫就可以了
})
new Vue({
  el: '#app',
  router,
  
  render: h => h(App)
})
